// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"pagination_paginationContainer__3BZcY","page":"pagination_page__2drLS"};